export { default } from './PopoverMenuItem';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/PopoverMenuItem/index.js